import React from "react";
export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) return (
      <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", background:"#060A13", color:"#E2E8F0", fontFamily:"'Outfit',sans-serif" }}>
        <div style={{ width:56, height:56, borderRadius:14, background:"linear-gradient(135deg,#EF4444,#DC2626)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, marginBottom:20, color:"#fff", fontWeight:800 }}>!</div>
        <h2 style={{ fontSize:22, fontWeight:700, marginBottom:8 }}>Something went wrong</h2>
        <p style={{ color:"#64748B", fontSize:14, marginBottom:24 }}>Your data is safe — it's encrypted in storage.</p>
        <button onClick={() => window.location.reload()} style={{ padding:"12px 28px", borderRadius:10, border:"none", background:"linear-gradient(135deg,#F5A623,#D4911C)", color:"#060A13", fontSize:14, fontWeight:700, cursor:"pointer" }}>Reload App</button>
      </div>
    );
    return this.props.children;
  }
}
